import { degrees2radians } from './degrees-2-radians';

export type ProjectOntoViewAxisParams = {
	/** Any point with world x/z — an island origin, a panel centre, a cutout. */
	point: { x: number; z: number };
	/** World angle of the face being looked at, in degrees. Any value; wrap is handled by cos/sin. */
	viewAngle: number;
};

/**
 * How far along a viewer's own left-to-right axis a point sits.
 *
 * Looking at a face whose world angle is `viewAngle`, the viewer's rightward direction is that angle
 * turned a quarter turn, so a point's world coordinates project straight onto it. This is the one
 * answer to "which of these is further left on screen", and it needs no angle compared to a constant,
 * no normalization (cos/sin wrap on their own) and no per-view flag: looking at the same thing from
 * behind is a 180 degree difference, which negates the result.
 * @param params the point and the world angle being viewed
 * @returns the signed distance along the viewer's rightward axis
 */
export const projectOntoViewAxis = (params: ProjectOntoViewAxisParams): number => {
	const { point, viewAngle } = params;
	const radians = degrees2radians(viewAngle);

	return (point.x * Math.cos(radians)) - (point.z * Math.sin(radians));
};
